import React from 'react'
import { PrbcReportContainer } from 'containers/Integrations/Reports/PrbcReportContainer'

export const PrbcReportPage = () => <PrbcReportContainer />
